import PropTypes from "prop-types";

import { useQuery } from "react-apollo";
import { ALL_SYSTEM_CODES_QUERY } from "../../graphql/SystemCodes/SystemCodes.graphql";

function SystemCodes({ variables, ...props }) {
  const payload = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables
  });
  return props.children(payload);
}
SystemCodes.propTypes = {
  children: PropTypes.func,
  variables: PropTypes.object
};

SystemCodes.defaultProps = {
  variables: {}
};
export default SystemCodes;
